import { defineStore } from "pinia";

export const useWizardStore = defineStore("wizard", {
  state: () => {
    return {
      step: 1,
      agentId: null,
      form: {},
      apiKeyOption: "new", // one of "new", "existing", "none"
      existingApiKey: null,
      apiKeyForm: {
        AllowedFrom: [
          { prefix: "0.0.0.0/0", note: "Allow entire Internet IPv4" },
          { prefix: "::/0", note: "Allow entire Internet IPv6" },
        ],
      },
      allowlistAccessIpRestrictionForm: {
        AllowedFrom: [
          { prefix: "0.0.0.0/0", note: "Allow entire Internet IPv4" },
          { prefix: "::/0", note: "Allow entire Internet IPv6" },
        ],
      },
      envVarsForm: { EnvVars: [{ Name: "", Value: "", Sensitive: false }] },
      knocOptionsForm: {},
      userIds: [],
      groupIds: [],
    };
  },
  actions: {
    changeStep(value) {
      this.step = value;
    },
    selectAgent(id) {
      this.agentId = id;
    },
    selectUser(id) {
      if (this.userIds.includes(id)) {
        this.userIds = this.userIds.filter((userId) => userId !== id);
      } else {
        this.userIds = [...this.userIds, id];
      }
    },
    selectGroup(id) {
      if (this.groupIds.includes(id)) {
        this.groupIds = this.groupIds.filter((groupId) => groupId !== id);
      } else {
        this.groupIds = [...this.groupIds, id];
      }
    },
  },
});
